import { SideNavCategory } from '../../../components/side-nav';
import { fetchSharedReports, SavedReport } from '../../../api';

const buildSharedWithMeCategory = async (clientId: number): Promise<
  SideNavCategory<unknown>
> => {
  const category: SideNavCategory<unknown> = {
    name: 'Shared With Me',
    key: 'Shared With Me',
    items: [],
  } as SideNavCategory<unknown>;

  const sharedReports = await fetchSharedReports(clientId);

  const sharedCategory: SideNavCategory<SavedReport> = {
    name: 'Shared With Me',
    key: 'Shared With Me',
    items: [],
    typeName: 'SharedReport',
    customSuffixMessage: 'have been shared with you',
  } as SideNavCategory<SavedReport>;

  sharedReports.forEach((e) => {
    sharedCategory.items.push({
      name: e.reportName,
      key: e.id.toString(),
      tag: e,
      typeName: 'SharedReport',
    });
  });

  category.items.push(sharedCategory);

  return category;
};

export { buildSharedWithMeCategory };
